export const ROOT = '/';
export const REGISTRO = '/onboarding';
export const MIGRACION = '/migracion';
export const POLITICA_PRIVACIDAD = '/politicasprivacidad';
export const OLVIDE_PASSWORD = '/recuperar-clave';
export const LOGIN_IDM_URL = `https://${process.env.REACT_APP_IDM_TENANT}.b2clogin.com/${process.env.REACT_APP_IDM_TENANT}.onmicrosoft.com/oauth2/v2.0/authorize?p=${process.env.REACT_APP_IDM_POLICY}&client_id=${process.env.REACT_APP_IDM_CLIENT_ID}&nonce=defaultNonce&redirect_uri=${process.env.REACT_APP_IDM_REDIRECT_URI}&scope=openid&response_type=id_token&prompt=login`;
export const HOME_PRIVADO_URL = `${process.env.REACT_APP_IDM_REDIRECT_URI}`;
export const HOME_PRIVADO_URL_LOGOUT = `${process.env.REACT_APP_IDM_REDIRECT_URI}/logout`;
